import { withLayout } from './layout';

export const inviteLearnerTemplate = ({ name, email, tempPassword, loginUrl }) => {
  const content = `
    <h2>Welcome to Sentinel Security Training</h2>
    <p>Hi ${name},</p>
    <p>You have been invited to join the Sentinel platform to complete your mandatory security awareness training.</p>
    <p>Your account has been configured with the following details:</p>
    <ul>
      <li><strong>Email:</strong> ${email}</li>
      <li><strong>Temporary Password:</strong> <span class="highlight">${tempPassword}</span></li>
    </ul>
    <p>Please log in using the button below. You will be prompted to change your password upon your first login to secure your account.</p>
    <div style="text-align: center;">
      <a href="${loginUrl}" class="button">Log In to Your Account</a>
    </div>
    <p>If you have any questions, please contact your IT administrator.</p>
  `;
  return withLayout(content, 'Welcome to Sentinel');
};